import { Modal, Upload, Button, Space, message } from "antd";
import { useEffect, useState } from "react";
import { UploadOutlined, DownloadOutlined } from '@ant-design/icons';
import service from "../../../@services";
import { getRequestHeader } from "../../../@utils/request.js";
import * as Utils from '../../../@utils';
import config from "../../../@config";
// eslint-disable-next-line import/no-anonymous-default-export
export default ({visible, taskType="", storeId="", close=()=>{}}) => {
  const fileNames = {
    '1': '商品档案批量导入模板',
    '2': '商品销售价格批量导入模板',
    '9': '门店商品批量导入模板'
  }
  const actions = {
    '1': 'product',
    '2': 'price',
    '9': 'store',
  }
  const onFileUploadSuccess = (file) => {
    if(!file||file.status!="done") return
    service[actions[taskType]].addFileTask({
      fileName: fileNames[taskType],
      fileUrl: file.response.data,
      taskType: taskType,
      businessContent: JSON.stringify({
        storeId: storeId,
        merchantId: "",
        merchantCode: ""
      })
    }).then((res)=>{
      message.success("导入数据成功")
    })
  }
  const downloadTemplate = () => {
    service.common.getFileTemplate({
      fileType:taskType === 1?'productTemplate': taskType === 2?'changePriceTemplate':'storeProductTemplate'
    }).then((res)=>{
      console.log()
      Utils.download(res, fileNames[taskType]+'.xlsx')
    })
  }

  return (
    <Modal
      title="批量添加"
      visible={visible}
      onCancel={close}
      footer={[
        <Button key="back" onClick={close}>关闭</Button>
      ]}
    >
      {
        <Space style={{display: "flex",justifyContent: "center", padding: "50px 0"}}>
          <Upload
            action={config.BASE_API+"/common/uploadFile"}
            showUploadList={false}
            headers={getRequestHeader()}
            onChange={({file})=>onFileUploadSuccess(file)}
          >
            <Button type="primary" icon={<UploadOutlined />}>上传文件</Button>
          </Upload>
          <Button type="primary" icon={<DownloadOutlined />} onClick={downloadTemplate}>下载模版</Button>
        </Space>
      }
    </Modal>
  )
}
